export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_06-826ffbf157e8f82aac52012245ce2ed3.jpg";